import "./index.less"
import Slideshow from './slider-swiper/index'
$(document).ready(function() {
    window.zModal = ZModle
    let params = {
        autoplay: $(".slide-swiper .slide-swiper-container").attr("data-autoplay") === "true" ? true : false,
        speed: Number($(".slide-swiper .slide-swiper-container").attr("data-speed")) || 8
    }

    new Slideshow(document.querySelector('.slide-swiper-container'), params)

    $(".section-exhibition--list .exhibition--list-tabs li").click(function() {
        if($(this).hasClass("active")) return
        $(".section-exhibition--list .exhibition--list-tabs li").removeClass("active");
        $('.section-exhibition--list').css('--translate-filters-slider', `${$(this).index() * 100}%`);
        $(this).toggleClass("active")



        const cate = $(this).attr("data-cate");
        $("jky-pagination-content").fadeOut().removeClass("hide");
        $(`jky-pagination-content[cate=${cate}]`).fadeIn('slow', function() {
            $("jky-pagination-content jky-exhibition-item").each(function() {
                $(this)[0].initTextMore()
            })
        });
    })

    // exhibition item
    if (!customElements.get('jky-exhibition-item')) {
        customElements.define('jky-exhibition-item', class JkyExhibitionItem extends HTMLElement {
            constructor() {
                super()

                this.init()
            }
            init() {
                const that = this
                const swiper = this.querySelector(".swiper")
                if(swiper.querySelectorAll(".swiper-slide").length > 1) {
                    $(this.querySelectorAll(".swiper-navigation-button")).show();
                    const prev = this.querySelector(".swiper-navigation-button.prev")
                    const next = this.querySelector(".swiper-navigation-button.next")
                    const pagination = this.querySelector(".swiper-pagination")
                    var ex_swiper = new Swiper(swiper, {
                        navigation: {
                            nextEl: next,
                            prevEl: prev,
                        },
                        pagination: {
                            el: pagination
                        },
                        spaceBetween: 20
                    });
                
                } else {
                    $(this.querySelectorAll(".swiper-navigation-button")).hide();
                }

                setTimeout(() => {
                    this.initTextMore()
                }, 20);

                $(this).find('.z-button-middle:not([cate="pastevents"] .z-button-middle)').click(function(e) {
                    e.preventDefault()    
                    console.log("dddd----", $(this), $(this).attr("data-type") === "true")

                    const link_type = $(this).attr("data-type") === "true" 
                    if(link_type) {
                        window.location.hash = $(this).attr("href").replace("#", "");
                        const hash = location.hash.replace("#", "");
                        const list_tab = $(`.form_tab-item[id=${hash}]`)[0]
        
                        if(list_tab) {
                            const _t_h = $(".form-tabs .section-title").outerHeight() || 0
                            const _icon_h = $(".form-tabs .form_tab_img").outerHeight() || 0
                            const _header_h = $("header").outerHeight() || 0
                            that.scrollToTop(list_tab, _t_h + _icon_h + _header_h + 30);
                        }
                    } else {
                        window.location.href = $(this).attr("href")
                    }
                })
            }

            scrollToTop(element, distance = 150) {
                if(!element) return;
                const rect = element.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const targetPosition = rect.top + scrollTop - distance;
                window.scrollTo({ top: targetPosition, behavior: 'smooth' });
            }

            initTextMore() {
                const m_media = window.matchMedia('(max-width: 1024px)').matches
                const line_num = m_media ? 4 : 3

                $(this).find(".exhibition-detail").each(function() {
                    const lineHeight = parseInt($(this).find(".text-overflow-3").css("line-height").replace("px",""));

                    const height = parseInt($(this).find(".text-overflow-3")[0].scrollHeight);
                    if((height / lineHeight) > line_num ) {
                        $(this).addClass("jky-tooltip");
                        $(this).find(".text-overflow-3").addClass("p-after")
                        $(this).find(".text-overflow-3").css("height",`${lineHeight * line_num}px`);
                        $(this).find(".jky-tooltip__inner").css("display",`block`);
                    } else {
                        $(this).removeClass("jky-tooltip");
                        $(this).find(".jky-tooltip__inner").css("display",`none`);

                        $(this).find(".text-overflow-3").removeClass("p-after");
                    }
                })

                $(this).find(".exhibition-name:not(jky-pagination-content[cate=pastevents] .exhibition-name)").each(function() {
                    const height_title = parseInt($(this)[0].scrollHeight);
            
                    if(height_title < 57  && !m_media) {
                        $(this).css("line-height", '56px');
                    }
                })
            }
        })
    }

    // 分页
    if (!customElements.get('jky-pagination-content')) {
        customElements.define('jky-pagination-content', class JkyPaginationContent extends HTMLElement {
            constructor() {
                super()

                if(window.innerWidth < 1024) {
                    return
                }
                
                this.pagination = {
                    per_page: Number(this.getAttribute("per_page")) || 6, // 每页数量
                    total: 0,
                    _total: 0,
                    current: 1,
                    type: this.getAttribute("pagination-type") // total | perpage (当前页码/总页数 | 每页编号显示)
                }
                this.paginationItem = this.getAttribute("target-dom") || "jky-exhibition-item" // 分页项选择器
                this.pagination.total = this.pagination._total =  Math.ceil($(this.querySelectorAll(this.paginationItem)).length / this.pagination.per_page) + 1; // 分页总数
                this.init();
            }
            init() {
                if(this.pagination.type === "perpage") {
                    const that = this;
                    let cntDownInterval = setInterval(adjustNumber, 500);
                    $(that.querySelectorAll('.pagination .prev_page,.pagination .next_page')).hide();
                    var adjustNumber = function () {
                        that.pagination.total--;
                        if( that.pagination.total > 0 ) {
                            $(that.querySelectorAll('.pagination')).prepend( $("<li><a>" + that.pagination.total + "</a></li>").addClass('pagi-' + that.pagination.total ).data('pagi', that.pagination.total) );

                        } else {
                            clearInterval(cntDownInterval);
                            $(that.querySelectorAll(that.paginationItem)).hide().slice(0, that.pagination.per_page).show();
                            $(that.querySelector('.pagi-1')).addClass('current');

                            $(that.querySelectorAll(".pagination [class^=pagi-]")).on("click", function() {
                                $(that.querySelector("[class^=pagi-]")).removeClass('current');
                                $(this).toggleClass('current');

                                var highSlice = $(this).data("pagi") * that.pagination.per_page;
                                var lowSlice = highSlice - that.pagination.per_page;

                                $(that.querySelectorAll(that.paginationItem)).fadeOut().slice( lowSlice, highSlice ).fadeIn();
                            });
                        }  
                    }
                    clearInterval(cntDownInterval);
                    cntDownInterval = setInterval(adjustNumber, that.pagination.per_page);
                } else {
                    this.querySelector(".pagination .pagination_content").innerHTML = `${this.pagination.current}/${this.pagination.total - 1}`

                    $(this.querySelectorAll(this.paginationItem)).hide().slice(0, this.pagination.per_page).show();
                    this.updatePagination();

                    this.querySelector(".pagination .prev_page").addEventListener("click", () => {
                        if(this.pagination.current > 1) {
                            this.pagination.current--;
                            this.updatePagination();
                        }
                    })

                    this.querySelector(".pagination .next_page").addEventListener("click", () => {
                        if(this.pagination.current < this.pagination._total - 1) {
                            this.pagination.current++;
                            this.updatePagination();
                        }
                    })
                }
            }
            updatePagination() {
                this.querySelector(".pagination .prev_page").classList.remove("disabled");
                this.querySelector(".pagination .next_page").classList.remove("disabled");

                if(this.pagination.current <= 1) {
                    this.pagination.current = 1;
                    this.querySelector(".pagination .prev_page").classList.add("disabled");
                }

                if(this.pagination.current >= this.pagination._total -1) {
                    this.pagination.current = this.pagination._total -1;
                    this.querySelector(".pagination .next_page").classList.add("disabled");
                }

                this.querySelector(".pagination .pagination_content").innerHTML = `${this.pagination.current}/${this.pagination.total - 1}`

                this.handlePage()
            }

            handlePage() {
                const that = this
                var highSlice = this.pagination.current * this.pagination.per_page;
                var lowSlice = highSlice - this.pagination.per_page;
                $(this.querySelectorAll(this.paginationItem)).fadeOut().slice( lowSlice, highSlice ).fadeIn('slow', function() {
                    $(that.querySelectorAll(that.paginationItem)).each(function() {
                        $(this)[0].initTextMore()
                    })
                });
                
                const _t_h = $(".form-tabs .section-title").outerHeight() || 0
                const _icon_h = $(".form-tabs .form_tab_img").outerHeight() || 0
                $('html, body').scrollTop($(this).offset().top - $("header").height() - 30 - _t_h - _icon_h);
            }
        })
    }
})
